import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import profile from '@assets/Images/profile11.png';

/**
 * Sidebar Header Component
 * Displays user profile information at the top of the sidebar
 * Memoized to prevent unnecessary re-renders
 * Optimized: Removed lodash dependency, added custom equality checks
 */
const SidebarHeader = React.memo(() => {
  const profileImage = useSelector(
    (state) => state?.userDetails?.details?.Photo__c,
    (prev, next) => prev === next
  );
  const userName = useSelector(
    (state) => state?.userDetails?.details?.Name,
    (prev, next) => prev === next
  );
  const userType = useSelector(
    (state) =>
      state?.userType?.type !== 'Other'
        ? state?.userType?.type
        : state?.userDetails?.details?.Title,
    (prev, next) => prev === next
  );

  // Memoize profile image URL
  const profileImageUrl = useMemo(() => {
    return profileImage && profileImage.trim()
      ? `data:image/png;base64,${profileImage}`
      : profile;
  }, [profileImage]);

  return (
    <div 
      className="px-4 py-4"
      style={{
        width: '100%',
        background: '#3901ff',
        height: '6rem'
      }}
    >
      <div className="flex items-center gap-4">
        <Link
          to="/my-profile"
          className="flex-shrink-0"
        >
          <img
            src={profileImageUrl}
            alt="Profile"
            style={{
              borderRadius: '50%',
              backgroundColor: '#fff',
              height: '3.5rem',
              width: '3.5rem',
              objectFit: 'cover'
            }}
          />
        </Link>
        <div className="flex-1 min-w-0">
          <h5 
            style={{
              fontFamily: 'Maven Pro, sans-serif',
              fontWeight: 500,
              fontSize: '1.121rem',
              lineHeight: '1.131rem',
              color: '#f9f9f9',
              margin: 0,
              marginBottom: '0.25rem'
            }}
          >
            {userName || 'User'}
          </h5>
          <p 
            style={{
              fontFamily: 'Maven Pro, sans-serif',
              fontWeight: 500,
              fontSize: '0.857rem',
              lineHeight: '1rem',
              color: '#f9f9f9',
              margin: 0
            }}
          >
            {userType || 'N/A'}
          </p>
        </div>
      </div>
    </div>
  );
});

SidebarHeader.displayName = 'SidebarHeader';

export default SidebarHeader;
